<template>
  <div>
    <div v-if="!text">
      <!-- <h3>Ano Anterior</h3> -->
      <canvas
        id="myChart46"
        width="40"
        height="5"
      />
      <div v-if="porcentagemExibicao">
        {{ porcentagemExibicao }}%
      </div>
    </div>
    <div
      v-else
    >
      {{ text }}
    </div>
  </div>
</template>

<script>
  import Chart from 'chart.js'
  import eventEmit from '../../../components/core/EventoEmit'

  export default {
    name: 'DashboardPorcentagemDevolucaoClientes',
    components: {
    },

    data: () => ({
      myChart: {},
      styleCliente: {
        color: '#ed934f',
      },
      enableGrafico: true,
      text: null,
      montaGrafico: true,
      porcentagem: 0,
      porcentagemExibicao: false,
      porcentagemAnterior: 0,
    }),

    created () {
      eventEmit.$on('set-dados-devolucao-cliente', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('set-dados-devolucao-cliente', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (porcentagemAtual, porcentagemAnterior) {
        this.porcentagem = porcentagemAtual
        this.porcentagemAnterior = porcentagemAnterior

        this.MontarGrafico()
      },

      MontarGrafico () {
        if (this.myChart.data) {
          this.myChart.destroy()
        }

        this.porcentagemExibicao = this.porcentagem.toFixed(2).toString().replace('.', ',')

        const ctx = document.getElementById('myChart46').getContext('2d')

        this.myChart = new Chart(ctx, {
          type: 'doughnut',
          data: {
            labels: ['Porcentagem', 'Porcentagem Anterior'],
            datasets: [
              {
                label: 'Faturamento',
                data: [this.porcentagem, this.porcentagemAnterior],
                backgroundColor: [
                  '#4780b8',
                  '#cadaed',
                ],
              },
            ],
          },
          options: {
            legend: {
              display: false,
            },
            responsive: true,
            circumference: 3.1,
            rotation: 3.15,
            cutoutPercentage: 70,
            tooltips: {
              enabled: false,
            },
          },
        })
      },
    },
  }
</script>

<style scoped>
  @media only screen
  and (min-device-width : 320px)
  and (max-device-width : 480px) {

  }
</style>

<style lang="sass">

</style>
